import 'magnific-popup';

const GALLERY_MODAL_SELECTOR = '.js-open-gallery';
const VIDEO_MODAL_SELECTOR = '.js-open-video';
const CLOSE_MARKUP = '<button title="%title%" type="button" class="mfp-close"><svg class="icon icon-times-circle"><use xlink:href="#icon-times-circle"></use></svg></button>';
const ARROW_MARKUP = '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><svg class="icon icon-angle-%dir%"><use xlink:href="#icon-angle-%dir%"></use></svg></button>';
const VIDEO_SETTINGS = {
  disableOn: 700,
  type: 'iframe',
  mainClass: 'mfp-fade',
  removalDelay: 160,
  preloader: false,
  fixedContentPos: false,
  closeMarkup: CLOSE_MARKUP
};

const GALLERY_SETTINGS = {
  delegate: 'a',
  type: 'image',
  mainClass: 'mfp-fade',
  closeMarkup: CLOSE_MARKUP,
  gallery: {
    enabled: true,
    navigateByImgClick: true,
    preload: [0, 1],
    tCounter: '',
    arrowMarkup: ARROW_MARKUP
  },
  callbacks: {
    buildControls: function() {
      // if(this.arrowLeft !== undefined) {
      //   this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      // }
      if ( typeof(this.arrowLeft) !== "undefined" && this.arrowLeft !== null ) {
        this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
      }
    }
  }
};

const init = () => {
  $(VIDEO_MODAL_SELECTOR).magnificPopup(VIDEO_SETTINGS);
  $(GALLERY_MODAL_SELECTOR).magnificPopup(GALLERY_SETTINGS);
};

export default init;
